"use client";

import React, { useContext, useMemo } from "react";
import { usePathname } from "next/navigation";
import { GlobalContext } from "@/contexts/SiteDataContext";
import withoutFooterNavPageList from "@/config/withoutFooterNavPageList";
import FooterNavigation from "@/components/molecules/FooterNavigation";
import FooterDisclaimer from "@/components/molecules/FooterDisclaimer";
import FooterCopyright from "@/components/molecules/FooterCopyright";
import classNames from "classnames";
import hideLanguageSelectorPageList from "@/config/hideLanguageSelectorPageList";
import { useFooterType } from "./useFooterType";
import "./footer.scss";

type FooterComponentProps = {
  template?: string;
  language: string;
  bigMaxWidth?: boolean;
  hideContactInfo?: boolean;
};

const FooterComponent: React.FC<FooterComponentProps> = ({
  template,
  language,
  bigMaxWidth,
  hideContactInfo,
}) => {
  const siteData = useContext(GlobalContext).context.siteData;
  const companyName = siteData.extraInfo.key;
  const pathnameWithoutBar = usePathname().replace("/", "");
  const showFooterNavigation = !withoutFooterNavPageList.includes(pathnameWithoutBar);
  const hideLanguageSelector = hideLanguageSelectorPageList.includes(pathnameWithoutBar);

  const styles = useMemo(
    () => require(`./templates/Footer.${template || "default"}/styles.module.scss`),
    [template]
  );

  const classnames = classNames("footer", {
    "footer--big-max-width": bigMaxWidth,
  });

  return (
    <footer className={`${classnames} ${styles.footer}`}>
      {showFooterNavigation && (
        <FooterNavigation
          language={language}
          hideLanguageSelector={hideLanguageSelector}
        />
      )}
      <FooterDisclaimer
        language={language}
        theme={siteData.theme}
        hideContactInfo={hideContactInfo}
      />
      <FooterCopyright company={companyName} />
    </footer>
  );
};

export default FooterComponent;
